<template>
    <div class='container w-100' style="position: relative; z-index: 999; background-color: #364768; color: white; border-radius: 30px; margin-top: 10px; margin-bottom: 50px; padding: 10px 10px 10px 10px; width: 60%;">
        <template v-if="this.unit_of_measure == 1">
            <b-row>
                
                <b-col cols="1">
                    <img :src="this.forecast.current_condition_icon" style="vertical-align: middle;" />
                </b-col>

                <b-col cols="3">
                        {{ this.forecast.forecast_date }}<br/>
                        Chance of rain {{this.forecast.forecast_daily_chance_of_rain}}%<br />
                        Max {{this.forecast.forecast_maxtemp_c}} &deg;C<br />
                        Min {{this.forecast.forecast_mintemp_c}} &deg;C<br />
                        Max Wind {{this.forecast.forecast_maxwind_kph}} kph<br />
                        Precipitation {{this.forecast.forecast_totalprecip_mm}}mm<br />
                </b-col>

                <b-col cols="1">
                    <img :src="this.day1.forecast_condition_icon" />
                </b-col>
                <b-col cols="3">
                    {{ this.day1.forecast_date }}<br />
                    Chance of rain {{this.day1.forecast_daily_chance_of_rain}}%<br />
                    Max {{this.day1.forecast_maxtemp_c}} &deg;C<br />
                    Min {{this.day1.forecast_mintemp_c}} &deg;C<br />
                    Max Wind {{this.day1.forecast_maxwind_kph}} kph<br />
                    Precipitation {{this.day1.forecast_totalprecip_mm}}mm<br />
                </b-col>
                <b-col cols="1">
                    <img :src="this.day2.forecast_condition_icon" />
                </b-col>
                <b-col cols="3">
                    {{ this.day2.forecast_date }}<br/>
                    Chance of rain {{this.day2.forecast_daily_chance_of_rain}}%<br />
                    Max {{this.day2.forecast_maxtemp_c}} &deg;C<br />
                    Min {{this.day2.forecast_mintemp_c}} &deg;C<br />
                    Max Wind {{this.day2.forecast_maxwind_kph}} kph<br />
                    Precipitation {{this.day2.forecast_totalprecip_mm}}mm<br />
                </b-col>
            </b-row>
        </template>
        <template v-if="this.unit_of_measure == 2">
            <b-row>
                <b-col cols="1">
                    <img :src="this.forecast.current_condition_icon" style="vertical-align: middle;" />
                </b-col>

                <b-col cols="3">
                    {{ this.forecast.forecast_date }}  <br/>
                    Chance of rain {{this.forecast.forecast_daily_chance_of_rain}}%<br />
                    Max {{this.forecast.forecast_maxtemp_f}} &deg;F<br />
                    Min {{this.forecast.forecast_mintemp_f}} &deg;F<br />
                    Max Wind {{this.forecast.forecast_maxwind_kph}} mph<br />
                    Precipitation {{this.forecast.forecast_totalprecip_in}}"<br />
                </b-col>
                <b-col cols="1">
                    <img :src="this.day1.forecast_condition_icon" />
                </b-col>
                <b-col cols="3">
                    {{ this.day1.forecast_date }}<br />
                    Chance of rain {{this.day1.forecast_daily_chance_of_rain}}%<br />
                    Max {{this.day1.forecast_maxtemp_f}} &deg;F<br />
                    Min {{this.day1.forecast_mintemp_f}} &deg;F<br />
                    Max Wind {{this.day1.forecast_maxwind_mph}} mph<br />
                    Precipitation {{this.day1.forecast_totalprecip_in}} "<br />
                </b-col>
                <b-col cols="1">
                    <img :src="this.day2.forecast_condition_icon" />
                </b-col>
                <b-col cols="3">
                    {{ this.day2.forecast_date }} <br />
                    Chance of rain {{this.day2.forecast_daily_chance_of_rain}}%<br />
                    Max {{this.day2.forecast_maxtemp_f}} &deg;F<br />
                    Min {{this.day2.forecast_mintemp_f}} &deg;F<br />
                    Max Wind {{this.day2.forecast_maxwind_mph}} mph<br />
                    Precipitation {{this.day2.forecast_totalprecip_in}} "<br />
                </b-col>
            </b-row>
        </template>
    </div>
</template>
<script>
    export default {
        name: "forecast",
        props: ['node_address'],
        data() {
            return {
                hardware_config_id: 0,
                unit_of_measure: 1,
                forecast: {
                    created_at: null,
                    current_cloud: null,
                    current_condition_code: null,
                    current_condition_icon: null,
                    current_condition_text: null,
                    current_humidity: null,
                    current_is_day: null,
                    current_last_updated: null,
                    current_last_updated_epoch: null,
                    current_precip_in: null,
                    current_precip_mm: null,
                    current_temp_c: null,
                    current_temp_f: null,
                    current_wind_dir: null,
                    current_wind_kph: null,
                    current_wind_mph: null,
                    hardware_config_id: null,
                    id: null,
                    location_country: null,
                    location_lat: null,
                    location_localtime: null,
                    location_localtime_epoch: null,
                    location_lon: null,
                    location_name: null,
                    location_region: null,
                    location_tz_id: null,
                    updated_at: null,
                    forecast_astro_sunrise: null,
                    forecast_astro_sunset: null,
                    forecast_condition_code: null,
                    forecast_condition_icon: null,
                    forecast_condition_text: null,
                    forecast_daily_chance_of_rain: null,
                    forecast_date: null,
                    forecast_date_epoch: null,
                    forecast_maxtemp_c: null,
                    forecast_maxtemp_f: null,
                    forecast_maxwind_kph: null,
                    forecast_maxwind_mph: null,
                    forecast_mintemp_c: null,
                    forecast_mintemp_f: null,
                    forecast_totalprecip_in: null,
                    forecast_totalprecip_mm: null,
                },
                day1: {
                    forecast_astro_sunrise: null,
                    forecast_astro_sunset: null,
                    forecast_condition_code: null,
                    forecast_condition_icon: null,
                    forecast_condition_text: null,
                    forecast_daily_chance_of_rain: null,
                    forecast_date: null,
                    forecast_date_epoch: null,
                    forecast_maxtemp_c: null,
                    forecast_maxtemp_f: null,
                    forecast_maxwind_kph: null,
                    forecast_maxwind_mph: null,
                    forecast_mintemp_c: null,
                    forecast_mintemp_f: null,
                    forecast_totalprecip_in: null,
                    forecast_totalprecip_mm: null,
                },
                day2: {
                    forecast_astro_sunrise: null,
                    forecast_astro_sunset: null,
                    forecast_condition_code: null,
                    forecast_condition_icon: null,
                    forecast_condition_text: null,
                    forecast_daily_chance_of_rain: null,
                    forecast_date: null,
                    forecast_date_epoch: null,
                    forecast_maxtemp_c: null,
                    forecast_maxtemp_f: null,
                    forecast_maxwind_kph: null,
                    forecast_maxwind_mph: null,
                    forecast_mintemp_c: null,
                    forecast_mintemp_f: null,
                    forecast_totalprecip_in: null,
                    forecast_totalprecip_mm: null,
                },
            }
        },
        methods: {
            loadWeatherFeedData(node_address) {
                console.log(node_address);
                //get the hw config latt lng for the forecast, and use the hwconfig id to delete the out of date forecast
            this.$axios.get("/api/get_id_for_forecast/" + node_address)
                .then((response1) => {
                    //console.log(response1);
                    this.$axios.get("/api/deleteForecast/" + response1.data.id)
                    .then((response2) => {
                       // console.log(response2);
                    });
                    //get the forcast  data and insert into a row
                    this.$axios.get('https://api.weatherapi.com/v1/forecast.json?key=097053c50474428491872501242507&q='+ + response1.data.latt+',' + response1.data.lng+'&days=3&aqi=no&alerts=no')
                        .then((response2) => {
                          //  console.log(response2);
                            this.$axios.post("/api/weather", { 'hardware_config_id': response1.data.id, 'weather_object': response2.data })
                                .then((response3) => {
                                        this.$axios.get("/api/loadWeatherFeedData/" + response1.data.id)
                                        .then((response4) => {
                                            console.log(response4.data);
                                            this.unit_of_measure = response4.data.unit_of_measure;
                                            this.forecast.created_at = response4.data[0].created_at;
                                            this.forecast.current_cloud = response4.data[0].current_cloud;
                                            this.forecast.current_condition_code = response4.data[0].current_condition_code;
                                            this.forecast.current_condition_icon = response4.data[0].current_condition_icon;
                                            this.forecast.current_condition_text = response4.data[0].current_condition_text;
                                            this.forecast.current_humidity = response4.data[0].current_humidity;
                                            this.forecast.current_is_day = response4.data[0].current_is_day;
                                            this.forecast.current_last_updated = response4.data[0].current_last_updated;
                                            this.forecast.current_last_updated_epoch = response4.data[0].current_last_updated_epoch;
                                            this.forecast.current_precip_in = response4.data[0].current_precip_in;
                                            this.forecast.current_precip_mm = response4.data[0].current_precip_mm;
                                            this.forecast.current_temp_c = response4.data[0].current_temp_c;
                                            this.forecast.current_temp_f = response4.data[0].current_temp_f;
                                            this.forecast.current_wind_dir = response4.data[0].current_wind_dir;
                                            this.forecast.current_wind_kph = response4.data[0].current_wind_kph;
                                            this.forecast.current_wind_mph = response4.data[0].current_wind_mph;
                                            this.forecast.hardware_config_id = response4.data[0].hardware_config_id;
                                            this.forecast.id = response4.data[0].id;
                                            this.forecast.location_country = response4.data[0].location_country;
                                            this.forecast.location_lat = response4.data[0].location_lat;
                                            this.forecast.location_localtime = response4.data[0].location_localtime;
                                            this.forecast.location_localtime_epoch = response4.data[0].location_localtime_epoch;
                                            this.forecast.location_lon = response4.data[0].location_lon;
                                            this.forecast.location_name = response4.data[0].location_name;
                                            this.forecast.location_region = response4.data[0].location_region;
                                            this.forecast.location_tz_id = response4.data[0].location_tz_id;
                                            this.forecast.updated_at = response4.data[0].updated_at;
                                            this.forecast.forecast_astro_sunrise = response4.data[0].forecast_astro_sunrise;
                                            this.forecast.forecast_astro_sunset = response4.data[0].forecast_astro_sunset;
                                            this.forecast.forecast_condition_code = response4.data[0].forecast_condition_code;
                                            this.forecast.forecast_condition_icon = response4.data[0].forecast_condition_icon;
                                            this.forecast.forecast_condition_text = response4.data[0].forecast_condition_text;
                                            this.forecast.forecast_daily_chance_of_rain = response4.data[0].forecast_daily_chance_of_rain;
                                            this.forecast.forecast_date = response4.data[0].forecast_date;
                                            this.forecast.forecast_date_epoch = response4.data[0].forecast_date_epoch;
                                            this.forecast.forecast_maxtemp_c = response4.data[0].forecast_maxtemp_c;
                                            this.forecast.forecast_maxtemp_f = response4.data[0].forecast_maxtemp_f;
                                            this.forecast.forecast_maxwind_kph = response4.data[0].forecast_maxwind_kph;
                                            this.forecast.forecast_maxwind_mph = response4.data[0].forecast_maxwind_mph;
                                            this.forecast.forecast_mintemp_c = response4.data[0].forecast_mintemp_c;
                                            this.forecast.forecast_mintemp_f = response4.data[0].forecast_mintemp_f;
                                            this.forecast.forecast_totalprecip_in = response4.data[0].forecast_totalprecip_in;
                                            this.forecast.forecast_totalprecip_mm = response4.data[0].forecast_totalprecip_mm;
                                            console.log(this.forecast);
                                            this.day1.forecast_astro_sunrise = response4.data[1].forecast_astro_sunrise;
                                            this.day1.forecast_astro_sunset = response4.data[1].forecast_astro_sunset;
                                            this.day1.forecast_condition_code = response4.data[1].forecast_condition_code;
                                            this.day1.forecast_condition_icon = response4.data[1].forecast_condition_icon;
                                            this.day1.forecast_condition_text = response4.data[1].forecast_condition_text;
                                            this.day1.forecast_daily_chance_of_rain = response4.data[1].forecast_daily_chance_of_rain;
                                            this.day1.forecast_date = response4.data[1].forecast_date;
                                            this.day1.forecast_date_epoch = response4.data[1].forecast_date_epoch;
                                            this.day1.forecast_maxtemp_c = response4.data[1].forecast_maxtemp_c;
                                            this.day1.forecast_maxtemp_f = response4.data[1].forecast_maxtemp_f;
                                            this.day1.forecast_maxwind_kph = response4.data[1].forecast_maxwind_kph;
                                            this.day1.forecast_maxwind_mph = response4.data[1].forecast_maxwind_mph;
                                            this.day1.forecast_mintemp_c = response4.data[1].forecast_mintemp_c;
                                            this.day1.forecast_mintemp_f = response4.data[1].forecast_mintemp_f;
                                            this.day1.forecast_totalprecip_in = response4.data[1].forecast_totalprecip_in;
                                            this.day1.forecast_totalprecip_mm = response4.data[1].forecast_totalprecip_mm;
                                            console.log(this.day1);
                                            this.day2.forecast_astro_sunrise = response4.data[2].forecast_astro_sunrise;
                                            this.day2.forecast_astro_sunset = response4.data[2].forecast_astro_sunset;
                                            this.day2.forecast_condition_code = response4.data[2].forecast_condition_code;
                                            this.day2.forecast_condition_icon = response4.data[2].forecast_condition_icon;
                                            this.day2.forecast_condition_text = response4.data[2].forecast_condition_text;
                                            this.day2.forecast_daily_chance_of_rain = response4.data[2].forecast_daily_chance_of_rain;
                                            this.day2.forecast_date = response4.data[2].forecast_date;
                                            this.day2.forecast_date_epoch = response4.data[2].forecast_date_epoch;
                                            this.day2.forecast_maxtemp_c = response4.data[2].forecast_maxtemp_c;
                                            this.day2.forecast_maxtemp_f = response4.data[2].forecast_maxtemp_f;
                                            this.day2.forecast_maxwind_kph = response4.data[2].forecast_maxwind_kph;
                                            this.day2.forecast_maxwind_mph = response4.data[2].forecast_maxwind_mph;
                                            this.day2.forecast_mintemp_c = response4.data[2].forecast_mintemp_c;
                                            this.day2.forecast_mintemp_f = response4.data[2].forecast_mintemp_f;
                                            this.day2.forecast_totalprecip_in = response4.data[2].forecast_totalprecip_in;
                                            this.day2.forecast_totalprecip_mm = response4.data[2].forecast_totalprecip_mm;
                                            console.log(this.day2);
                                        });
                                });
                        });
                    //display the forecast
                });
        },
        },
        created() {
            this.loadWeatherFeedData(this.node_address);
        },
    };
</script>
